// Modül KODUNU (SM, PM, AT …) kullanıcıya gösterilecek MODÜL ADINA çevirir.
//
// Neden var (Modül Bazlı Lisanslama, düzeltme turu 4 — Kü-7): çalışan detayındaki
// "Lisanslar" kartı `EmployeeResponse.Seats` içindeki HAM KODLARI basıyordu — kullanıcı
// "SM", "PM", "AT" görüyordu. Bu hem çevrilmemiş hem jargon (`feedback_modern_ui_dili`).
//
// NEDEN YENİ ÇEVİRİ ANAHTARI EKLENMEDİ: modül adları zaten 5 locale'de var ve sol menünün
// GRUP etiketleri olarak kullanılıyor (MenuConfig'teki grup `labelKey`'leri). Yeni bir
// `license.moduleName.*` ailesi eklemek 23 × 5 = 115 mükerrer değer üretir ve iki kaynak
// zamanla ayrışır. Buradaki eşleme MenuConfig'in kendi grup etiketleriyle BİREBİRDİR.
//
// NEDEN /v1/licenses/usage'ın `name` alanı KULLANILMADI: o uç sınıf düzeyinde
// [ModuleAuthorize("EM","Write")] taşır — çalışan detayını açan sıradan kullanıcı 403 alır.
//
// Bilinmeyen kod ham gösterilir: yeni bir modül eklenip bu listeye girmezse kullanıcı eskisi
// gibi kodu görür (bilgi KAYBOLMAZ), kart boş kalmaz. Listeyi tazelemeyi unutan görev için
// güvenlik ağı moduleNames.test.js'teki "her anahtar 5 locale'de VAR" iddiasıdır.
export const MODULE_NAME_KEYS = {
  EM: 'menu.employeeManagement',
  LM: 'menu.leaveManagement',
  TA: 'menu.timeAttendance',
  SM: 'menu.shiftManagement',
  AC: 'menu.accessControl',
  AT: 'menu.ats',
  PB: 'menu.preboarding',
  OB: 'menu.onboarding',
  OD: 'menu.offboarding',
  PM: 'menu.performanceManagement',
  TD: 'menu.talentDevelopment',
  TR: 'menu.training',
  EX: 'menu.expenseManagement',
  AM: 'menu.assetManagement',
  CN: 'menu.canteen',
  VM: 'menu.visitorManagement',
  BN: 'menu.benefits',
  SV: 'menu.surveys',
  AN: 'menu.announcements',
  RF: 'menu.raffles',
  ET: 'menu.ethicsCompliance',
  IL: 'menu.importantLinks',
  HA: 'menu.hrAnalytics',
  // Public API — menüdeki yüzeyi "Entegrasyonlar" (API anahtarı izin etiketleri de bunu kullanır).
  PA: 'menu.integrations',
};

/** Modül kodunun çeviri anahtarı; bilinmeyen kodda null. */
export const moduleNameKey = (code) => MODULE_NAME_KEYS[code] || null;

/** Çevrilmiş modül adı; bilinmeyen kodda kodun kendisi. */
export function moduleName(t, code) {
  const key = moduleNameKey(code);
  return key ? t(key) : code;
}
